import { forwardRef } from 'react';

import * as St from './HorizontalScrollContainer.styles';

import ArrowButton from '~atoms/ArrowButton';

type HorizontalScrollContainerProps = {
  children: React.ReactNode;
  goToNext?: () => void;
  goToPrev?: () => void;
};

const HorizontalScrollContainer = forwardRef<
  HTMLDivElement,
  HorizontalScrollContainerProps
>(
  (
    { children, goToNext, goToPrev }: HorizontalScrollContainerProps,
    listRef
  ) => (
    <St.Container>
      <div style={{ position: 'relative', width: '90rem' }}>
        <ArrowButton
          direction="left"
          handleClick={() => {
            goToPrev?.();
          }}
          ariaProps={{ 'aria-label': 'Scroll Left' }}
          iconStyleProps={{ fontSize: '30rem' }}
          btnStyleProps={{ left: '-15rem' }}
        />
      </div>
      <St.List
        ref={listRef}
        tabIndex={0}
        role="region"
        aria-labelledby="scrollable-region-label"
      >
        {children}
      </St.List>
      <div style={{ position: 'relative', width: '100rem' }}>
        <ArrowButton
          direction="right"
          handleClick={() => {
            goToNext?.();
          }}
          ariaProps={{ 'aria-label': 'Scroll Right' }}
          iconStyleProps={{ fontSize: '30rem' }}
          btnStyleProps={{ right: '-15rem' }}
        />
      </div>
    </St.Container>
  )
);

HorizontalScrollContainer.displayName = 'HorizontalScrollContainer';

export default HorizontalScrollContainer;
